import React from 'react';

import type { Text } from '@zillow/constellation';
import { AdornedInput, Adornment, FormField, FormHelp, Label } from '@zillow/constellation';
import { CurrencyInput } from '@zillow/zrs-comet';

import type { HTMLElementEvent } from '../../../models/Types';
import type { Section } from '../../..//models';
import { LATE_RENT } from '../../../constants';
import { CURRENCY_INPUT_PLACEHOLDER } from '../../../constants/stringConstants';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function LateRent_v2({ section, setSectionValues }: Props): JSX.Element {
  function onLateFeeChange(event: HTMLElementEvent<typeof Text>): void {
    const { value } = event.currentTarget;

    setSectionValues({
      [LATE_RENT.FIELD_NAME.FEE_AMOUNT]: value,
    });
  }

  return (
    <FormField
      label={<Label size="lg">What is the fee for late rent?</Label>}
      control={
        <AdornedInput
          leftAdornment={<Adornment>$</Adornment>}
          rightAdornment={<Adornment>flat fee</Adornment>}
          input={
            <CurrencyInput
              placeholder={CURRENCY_INPUT_PLACEHOLDER}
              value={section.getFieldValue(LATE_RENT.FIELD_NAME.FEE_AMOUNT)}
              onChange={onLateFeeChange}
              onBlur={onLateFeeChange}
            />
          }
          error={section.getField(LATE_RENT.FIELD_NAME.FEE_AMOUNT).hasError}
        />
      }
      description={
        section.getField(LATE_RENT.FIELD_NAME.FEE_AMOUNT).hasError && (
          <FormHelp error>{section.getField(LATE_RENT.FIELD_NAME.FEE_AMOUNT).getErrorMessage()}</FormHelp>
        )
      }
    />
  );
}

LateRent_v2.description = 'Late rent without days late, only fee assessed.';
